import React from 'react'
import './Breadcrum.css'
import { Link } from 'react-router-dom';

// links to categories 
const CATEGORY_ROUTES = {
    women: '/womens',
    men:   '/mens',
    kids:  '/kids',
    other: '/others',
}

const Breadcrum = (props) => {

  const { product } = props;

  const categoryPath  = CATEGORY_ROUTES[product.category] || '/shop-products'
  const categoryLabel = product.category.charAt(0).toUpperCase() + product.category.slice(1)

  return (
    <div className='breadcrum'>

        <Link to='/'>Home</Link>
        {" / "}
        <Link to='/shop-products'>Shop</Link>
        {" / "}
        <Link to={categoryPath}>{categoryLabel}</Link>
        {" / "}
        <span className='breadcrum-current'>{product.name}</span>
        
    </div>
  )
}

export default Breadcrum